module.exports = __webpack_public_path__ + "img/turn.64fb5ac3.svg";